import { render, staticRenderFns } from "./UserResult.vue?vue&type=template&id=a6946bda&"
import script from "./UserResult.vue?vue&type=script&lang=js&"
export * from "./UserResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports